var localmed;

localmed = {
  defaults: {
    activeClass: 'is-active',
    disabledClass: 'is-disabled'
  }
};

module.exports = localmed;
